import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import useWarehouseQuoteExpeditionService from '../../../../../app/services/hooks/useWareHouseQuoteExpeditionService';
import { defaultWarehouseExpeditionDataForm, WarehouseExpeditionDataForm } from '../../../../../app/models/WareHouseQuoteExpedition';
import WarehouseExpeditionForm from './forms/WareHouseExpeditionForms/WareHouseExpeditionForm';
import { Currency } from '../../../../../app/models/Currency';
import { Depot } from '../../../../../app/models/Depot';
import { PackingType } from '../../../../../app/models/PackingType';
import { Place } from '../../../../../app/models/Place';
import { RouteSegment } from '../../../../../app/models/RouteSegment';
import { Unit } from '../../../../../app/models/Unit';
import useReactConfirmAlert from '../../../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../../../contexts/AppContext';

interface Props {
    expeditionId: number;
    onSaved: () => void;
    onCancel: () => void;
}
// editWarehouseQuoteExpedition
const WarehouseQuoteExpeditionEdit = ({ expeditionId, onSaved, onCancel }: Props) => {
    const { updateWarehouseQuoteExpedition, editWarehouseQuoteExpedition } = useWarehouseQuoteExpeditionService();
    const [warehouseExpeditionform, setWarehouseExpeditionform] = useState<WarehouseExpeditionDataForm>({...defaultWarehouseExpeditionDataForm});
    const [origins, setOrigins] = useState<Place[]>([]);
    const [destinations, setDestinations] = useState<Place[]>([]);
    const [depots, setDepots] = useState<Depot[]>([]);
    const [routeSegments, setRouteSegments] = useState<RouteSegment[]>([]);
    const [currencies, setCurrencies] = useState<Currency[]>([]);
    const [units, setUnits] = useState<Unit[]>([]);
    const [packingTypes, setPackingTypes] = useState<PackingType[]>([]);
    const [errorFields, setErrorFields] = useState<any>();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    useEffect(() => {
        edit();
    }, [expeditionId]);
    
    const edit = () => {
            editWarehouseQuoteExpedition(expeditionId, {
                onSuccess: (response: ServiceResponse) => {
                    const data = response.data.warehouse_quote_expedition;
                    setWarehouseExpeditionform( response.data.warehouse_quote_expedition);
                    setOrigins(response.data.origins);
                    setDestinations(response.data.destinations);
                    setDepots(response.data.depots);
                    setRouteSegments(response.data.route_segments);
                    setCurrencies(response.data.currencies);
                    setUnits(response.data.units);
                    setPackingTypes(response.data.packing_types);
                },
                onError: (response: ServiceResponse) => {
                    toast.error('Error al cargar almacenamiento');
                }
            });
    };
    

    const update = () => {
        updateWarehouseQuoteExpedition(expeditionId, warehouseExpeditionform, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
    
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
    
                toast.success(response.message, { autoClose: 2500 });
                setErrorFields(undefined);
                 if (onSaved) onSaved();

            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

    
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });

                toast.error(response.message);
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setErrorFields(errorFields.data);
            }
        });
    };

    return (
        <>
            <WarehouseExpeditionForm
                expeditionDataForm={warehouseExpeditionform}
                setExpeditionDataForm={setWarehouseExpeditionform}
                origins={origins}
                destinations={destinations} 
                depots={depots}
                routeSegments={routeSegments}
                currencies={currencies}
                units={units}
                packingTypes={packingTypes}   
                errorFields={errorFields}
                />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={onCancel} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={update} />
                </div>
            </div>
        </>
    );
};

export default WarehouseQuoteExpeditionEdit;
